import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Status from "../Status/Status";
import { _IDOSaleTotalCollectedFunds } from "../../Services/Web3Connection";
export default function LaunchpadComponent(props) {
  const [RaisedAmmount, setRaisedAmmount] = useState(0);
  const [DescriptionData, setDescriptionData] = useState("");
  useEffect(async () => {
    let data = await _IDOSaleTotalCollectedFunds(props.data[2][1]);
    setRaisedAmmount(data);
    DataDetails(data);
    setDescriptionData(props.data[3][9]);
  }, []);

  function DataDetails(data) {
    setRaisedAmmount(data);
  }
  return (
    <>
      {/* <img class="infinitypageimg" src="%PUBLIC_URL%/assets/images/bg1.jpg" /> */}

      <div className="container">
        <div className="mb-5">
          {/* <Link to={`/launchpad/${props.data[2][1]}`> */}
          <div data-v-cbeecb6c="" data-v-5b46e2aa="" class="pool">
            <div data-v-cbeecb6c="" class="pool__container">
              <div data-v-cbeecb6c="" class="pool__top">
                <div data-v-cbeecb6c="" class="pool__ava">
                  <img data-v-cbeecb6c="" src={props.data[3][0]} alt="ava" />
                </div>
                <div>
                  {/* <div data-v-cbeecb6c="" class="pool__network">
                    <span className="text-warning">{props.data[0][1]}</span>
                  </div> */}
                </div>
                <div data-v-cbeecb6c="" class="pool__network">
                  {/* {console.log(Math.ceil(RaisedAmmount), "raised amt")} */}
                  <Status
                    startDate={props.data[1][3]}
                    endDate={props.data[1][4]}
                    hardCap={props.data[1][2]}
                    raisedAmount={RaisedAmmount}
                  />
                </div>
              </div>
            </div>
            <div data-v-cbeecb6c class="pool__scroll">
              <div data-v-cbeecb6c class="pool__title">
                {props.data[0][0]}
              </div>
              <div data-v-cbeecb6c class="pool__sub">
                {DescriptionData === "" ? (
                  <div
                    style={{
                      color: "white",
                      fontFamily: "Outfit, sans-serif",
                      fontSize: "12px",
                    }}
                  >
                    ‘Alisia’, a massive magical planet in the {props.data[0][0]}
                    verse, is home to the majestic {props.data[0][0]}mon
                    creatures. These creatures each possess their own magical
                    abilities known as ‘elements’. There are a number of said
                    elements including fire, water, wind, metal, and nature. The
                    potency of the {props.data[0][0]}mon is determined by their
                    rarity and their genes. Some of these genes include luck,
                    accuracy, attack, intelligence and many more. These genes
                    all add up to {props.data[0][0]}mon that have thirty
                    different levels of strength within the Bronze, Silver, and
                    Gold stages.
                  </div>
                ) : (
                  DescriptionData
                )}
                {/* {console.log(props.data[3][9])} */}
              </div>
            </div>
            <div data-v-cbeecb6c className="pool__launch-info">
              <div data-v-cbeecb6c className="pool__label">
                Raised Amount
              </div>
              <div data-v-cbeecb6c className="pool__values">
                <div data-v-cbeecb6c className="pool__value">
                  {/* {console.log(RaisedAmmount / Math.pow(10, 18))} */}
                  {RaisedAmmount / Math.pow(10, 18) + " " + "BUSD"}
                </div>
              </div>

              <div
                data-v-cbeecb6c
                className="pool__progress d-flex"
                style={{ justifyContent: "space-between", opacity: "80%" }}
              >
                Min goal {props.data[1][2] / Math.pow(10, 18)} BUSD
                <Link to={`/launchpad/${props.data[2][1]}`}>
                  <button className="cartbtn mr-3">view info</button>
                </Link>
              </div>
              {console.log()}
              <div className="progress mt-2 mr-3" style={{ height: "0.5rem" }}>
                <div
                  className="progress-bar cardprogressbarcolor"
                  role="progressbar"
                  style={{
                    width: `${
                      (RaisedAmmount /
                        Math.pow(10, 18) /
                        (props.data[1][2] / Math.pow(10, 18))) *
                        100 >
                      100
                        ? 100
                        : (RaisedAmmount /
                            Math.pow(10, 18) /
                            (props.data[1][2] / Math.pow(10, 18))) *
                          100
                    }%`,
                  }}
                  aria-valuenow={25}
                  aria-valuemin={0}
                  aria-valuemax={100}
                />
              </div>
            </div>{" "}
          </div>

          {/* -----bottom content------- */}
          <div className="bottomcard">
            <div data-v-cbeecb6c="" class="pool__cover cover">
              <div data-v-cbeecb6c="" class="cover__item">
                <div data-v-cbeecb6c="" class="cover__label">
                  Swap Rate
                </div>
                <div data-v-cbeecb6c="" class="cover__value">
                  {props.data[1][0] / Math.pow(10, 18) +
                    " " +
                    props.data[0][1].toString().toUpperCase() +
                    " " +
                    "per BUSD"}
                </div>
              </div>
            </div>
          </div>

          {/* ----close bottom content----- */}
        </div>
        {/* </Link>  */}
      </div>
    </>
  );
}
